import { defineAsyncComponent } from 'vue';

const SummaryAuditSTCDetail = defineAsyncComponent(() =>
  import('@/views/auditSummary/popup/SummaryAuditSTCDetail.vue'),
);

const summaryAuditHCSNRegularDetail = defineAsyncComponent(() =>
  import('@/views/auditSummary/popup/SummaryAuditHCSNRegularDetail.vue')
);

const summaryAuditHCSNProjectDetail = defineAsyncComponent(() =>
  import('@/views/auditSummary/popup/SummaryAuditHCSNProjectDetail.vue')
);

const SummaryAuditSTCFeedback = defineAsyncComponent(() =>
  import('@/views/auditSummary/popup/SummaryAuditSTCFeedback.vue'),
);

const SummaryAuditReturnNotifyPopup = defineAsyncComponent(() =>
  import('@/views/auditSummary/popup/SummaryAuditReturnNotifyPopup.vue'),
);

const SummaryAuditSTCComplete = defineAsyncComponent(() =>
  import('@/views/auditSummary/popup/SummaryAuditSTCComplete.vue'),
);

const utilityUpdateAuditQuickly = defineAsyncComponent(() =>
  import('@/views/auditSummary/popup/UtilityUpdateAuditQuickly.vue'),
);

const summaryAuditExplanationDetailPopup = defineAsyncComponent(() =>
  import('@/views/auditSummary/popup/SummaryAuditExplanationDetailPopup.vue')
);

const summaryAuditSalaryExplanationDetailPopup = defineAsyncComponent(() =>
  import('@/views/auditSummary/popup/SummaryAuditSalaryExplanationDetailPopup.vue')
);

const auditEstimateSalaryCoefficientPopup = defineAsyncComponent(() => import('@/views/auditArrgrate/popup/AuditEstimateSalaryCoefficientPopup.vue'));
const AuditEstimateSalaryCoefficientCommentPopup = defineAsyncComponent(() => import('@/views/auditArrgrate/popup/AuditEstimateSalaryCoefficientCommentPopup.vue'));
export function auditRegister(app) {
  app.component('SummaryAuditSTCDetail', SummaryAuditSTCDetail);
  app.component('SummaryAuditHCSNRegularDetail', summaryAuditHCSNRegularDetail);
  app.component('SummaryAuditHCSNProjectDetail', summaryAuditHCSNProjectDetail);
  app.component('SummaryAuditSTCFeedback', SummaryAuditSTCFeedback);
  app.component('SummaryAuditReturnNotifyPopup', SummaryAuditReturnNotifyPopup);
  app.component('UtilityUpdateAuditQuickly', utilityUpdateAuditQuickly);
  app.component('AuditEstimateSalaryCoefficientPopup', auditEstimateSalaryCoefficientPopup);
  app.component('AuditEstimateSalaryCoefficientCommentPopup', AuditEstimateSalaryCoefficientCommentPopup);
  app.component('SummaryAuditSTCComplete', SummaryAuditSTCComplete);
  app.component('SummaryAuditExplanationDetailPopup', summaryAuditExplanationDetailPopup);
  app.component('SummaryAuditSalaryExplanationDetailPopup', summaryAuditSalaryExplanationDetailPopup);
}
